import React from 'react';
import './AboutBanner.css'
import { Link } from 'react-router-dom';

function AboutBanner() {
  return (
    <div className='about-banner-outer d-flex justify-content-center align-items-center flex-column'>
      <h1 className='header-text'>Making Careers Since 2013</h1>
      <p className="cta-text">LIMS Hotel Management Institute offers diploma and <br/> certificate programs in hospitality and hotel management. </p>
      <button className='cta-text'><Link to='/contact'>Admission Open</Link></button>
    </div>
  )
}

export default AboutBanner
